import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getRoleDetailFetchSuccess,
    getRoleDetailFetchFailure,
    createRoleDetailFetchSuccess,
    createRoleDetailFetchFailure,
    updateRoleDetailFetchSuccess,
    updateRoleDetailFetchFailure,
} from './reducer';
import { RoleDetailResType } from 'src/types/roleDetail';
import { RoleType } from 'src/types/role';
import translate from '@translate';

const getRoleDetailFetchRequest = async (idRole: string) => {
    const res = await api('get', `api/secure/roles/permission/${idRole}`);
    return res.data;
};

function* getRoleDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: RoleDetailResType = yield call((): any => getRoleDetailFetchRequest(action.payload));
        yield put(getRoleDetailFetchSuccess(response));
    } catch (error) {
        yield put(getRoleDetailFetchFailure({ error }));
    }
}

export function* getRoleDetailFetchWatch() {
    yield takeEvery('roleDetail/getRoleDetailFetch', getRoleDetailFetch);
}

const createRoleDetailFetchRequest = async (data: RoleType) => {
    const res = await api('post', 'api/secure/roles/permission', data);
    return res.data;
};

function* createRoleDetailFetch(action: { type: string; payload: RoleType }) {
    try {
        const response: RoleDetailResType = yield call((): any => createRoleDetailFetchRequest(action.payload));
        yield put(
            createRoleDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('roles.message.roleCreated') },
            })
        );
    } catch (error) {
        yield put(createRoleDetailFetchFailure({ error }));
    }
}

export function* createRoleDetailFetchWatch() {
    yield takeEvery('roleDetail/createRoleDetailFetch', createRoleDetailFetch);
}

const updateRoleDetailFetchRequest = async (params: { idRole: string; data: RoleType }) => {
    const res = await api('put', `api/secure/roles/permission/${params.idRole}`, params.data);
    return res.data;
};

function* updateRoleDetailFetch(action: { type: string; payload: { idRole: string; data: RoleType } }) {
    try {
        const response: RoleDetailResType = yield call((): any => updateRoleDetailFetchRequest(action.payload));
        yield put(
            updateRoleDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('roles.message.roleUpdate') },
            })
        );
    } catch (error) {
        yield put(updateRoleDetailFetchFailure({ error }));
    }
}

export function* updateRoleDetailFetchWatch() {
    yield takeEvery('roleDetail/updateRoleDetailFetch', updateRoleDetailFetch);
}
